import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import BodmasTestQuestionTable from './BodmasTestQuestionTable';

const BodmasTestQuestions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Bodmas Test Questions' parent='Bodmas Test Questions'  />
      <Container fluid={true}>
        <Row>
          <BodmasTestQuestionTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BodmasTestQuestions;
